import React from 'react';
import { Accordion } from '@mantine/core';
import './styles.scss';

export const AccordionSection = ({ data }) => {
  const CustomChevron = () => <img src="/images/icon-chevron-arrow.svg" className="w-5 h-5" />;

  const items = data.map((item, index) => (
    <Accordion.Item
      key={`item-${index}`}
      value={`item-${index}`}
      className={index === data.length - 1 ? 'last-item' : ''}
    >
      <Accordion.Control className="text-white pl-0" chevron={<CustomChevron />}>
        {item.title}
      </Accordion.Control>
      <Accordion.Panel className="text-white fs-p">{item.description}</Accordion.Panel>
    </Accordion.Item>
  ));

  return (
    <Accordion defaultValue="item-0" className="mx-auto accordion-container">
      {items}
    </Accordion>
  );
};

export default AccordionSection;
